import { Formik, useFormikContext, getIn } from "formik";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import AutocompleteObjectV2 from "../../../component/AutocompleteObjectV2";
import ButtonInPhieu from "../../../component/button-in-phieu";
import LabelRequired from "../../../component/LabelRequired";
import TextField from "../../../component/TextField";
import { IDanhSachDanhMuc } from "../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import {
  APP_TIMESTAMP_FORMAT,
  CODE,
  KEY_DS_DANH_MUC_TIEP_DON,
  RESPONSE_MESSAGE,
} from "../../../utils/Constant";
import { formatDateDTO, formatDateTime } from "../../../utils/FormatUtils";
import { getIndexedDBItem } from "../../../utils/IndexedDB";
import WfButton from "../../../workflows/components/WfButton";
import { WfConstTracker } from "../../../workflows/Constant";
import ICD10 from "../../components/ICD10";
import { MEDICAL_CONCLUSION_MODALITY } from "../../constants/phan-he-kham-benh/ConstantPhanHeKhamBenh";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import DynamicModal from "../../modals/modal-tab-xu-tri/DynamicModal";
import ModalCapToaChoVe from "../../modals/modal-tab-xu-tri/ModalCapToaChoVe";
import ChuyenPhongKhamModal from "../../modals/modal-tab-xu-tri/ModalChuyenPhongKham";
import "../../PhanHeKhamBenh.scss";
import {
  getDataXuTriService, updateConclusionDate,
} from "../../services/KhamBenhService";
import { inPhieuChuyenPK, inPhieuKhamBenh } from "../../services/PrintExportService";
import ChuyenTuyenModal from "../../modals/modal-tab-xu-tri/modal-chuyen-tuyen/ModalChuyenTuyen";
import ModalCapNhatThongTinTuVong from "../../modals/modal-tab-xu-tri/ModalCapNhatThongTinTuVong";
import DatePickerCustom from "../../../component/date-picker/DatePickerCustom";
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import ProvisonalDiagnosis from "../../components/ProvisonalDiagnosis";
import ModalNhapVien from "../../modals/modal-tab-xu-tri/modal-nhap-vien";
import { DatLichHenButton } from "../../components/dat-lich-hen";
import { isValidAppointment } from '../../components/dat-lich-hen/utils';
import ModalDieuTriNgoaiTru from '../../modals/modal-tab-xu-tri/modal-dieu-tri-ngoai-tru';
import { getAppointmentByVisit, printGiayHenKham } from "../../services/DatLichHenService";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";

export type KhamBenh = {
  thongTinKhamBenh?: any;
  setThongTinKhamBenh: ((data: any) => void) | undefined;
};

type Props = {
  handleSubmit: (values: any, workflowCallbackFn?:() => void, cancel?: () => void) => any;
  listHTXT: any;
  listKQ: any;
  setListHTXT: (data: any) => void;
  setModalityDetails: (data: any) => void;
  modalityDetails: any;
  listICD10: any;
  listYHCT: any[];
};

export const TabXuTri = (props: Props) => {
  let {
    handleSubmit,
    listHTXT,
    listKQ,
    setModalityDetails,
    modalityDetails,
    listICD10,
    listYHCT,
  } = props;
  const { values, setValues, setFieldValue, errors, touched, submitForm, resetForm } =
		useFormikContext<any>();
  const { benhNhanInfo, setBenhNhanInfo, statusChangedEventFunc } =
		useContext(PhanHeTiepDonContext);
  let componentName = "TabXuTri";
  
  const encounterDiagnosisValues = useMemo(() => {
	  return { ...values?.encounterDiagnosis, orderId: benhNhanInfo?.thongTinKhamBenh?.orderId };
  }, [values?.encounterDiagnosis, benhNhanInfo?.thongTinKhamBenh?.orderId]);
	const allowEdit = hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.XU_TRI);

  const [nameComp, setNameComp] = useState<string | undefined>("");
  const [shouldOpenModalICD10, setShouldOpenModalICD10] =
    useState<boolean>(false);
  const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] =
    useState<boolean>(false);
  const [listComorbidity, setListComorbidity] = useState<any[]>([]);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [diagnostic, setDiagnostic] = useState<{
    fieldName: string;
    fieldLabel: string;
    comorbidityField: string;
    comorbidityCodeField: string;
    options: any[];
  }>({
    fieldName: '',
    fieldLabel: '',
    comorbidityField: '',
    comorbidityCodeField: '',
    options: [],
  });

	const timeEditorManager = useTimeEditorManager({
		name: "medicalConclusionDate",
		idFieldName: "orderId",
		values: encounterDiagnosisValues,
		updateFields: updateConclusionDate,
		onUpdateSuccess: (updatedData) => {
			handleChangeEncounterDiagnosis('medicalConclusionDate', updatedData?.medicalConclusionDate);
		}
	});

  const handleSelectOption = (option: any, name: string) => {
    setFieldValue(name, option);

    if (!option) return;

    const isHideOptionOpenDialog = option?.attributes?.isOpenDialog === 'f';
    if (isHideOptionOpenDialog) return;
    
    setNameComp(option?.code);
  };

  const handleCloseModal = () => {
    setNameComp("");
  };

  const handleSubmitModal = (values: any) => {
    setModalityDetails({
      ...modalityDetails,
      ...values,
    });
    values?.doctorComment && handleChangeEncounterDiagnosis("doctorComment", values.doctorComment);
    handleCloseModal();
  };

  const compArray = {
    [MEDICAL_CONCLUSION_MODALITY.NHAP_VIEN.code]: (
      <ModalNhapVien
        open
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(values: any) => handleSubmitModal(values)}
        modalityDetails={modalityDetails}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY.CHUYEN_TUYEN.code]: (
      <ChuyenTuyenModal
        open={true}
        xuTriData={encounterDiagnosisValues}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(data: any) => {
          setFieldValue("encounterDiagnosis", {
            ...encounterDiagnosisValues,
            icdXPrimary: data?.htDiagnosis,
            icdXPrimaryName: data?.htDiagnosisName,
            comorbidity: data?.htComorbidity,
          });
          handleSubmitModal(data);
        }}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY.HET_DOT_NGOAI_TRU.code]: "",
    [MEDICAL_CONCLUSION_MODALITY.CHUYEN_PHONG.code]: (
      <ChuyenPhongKhamModal
        open={true}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(values: any) => handleSubmitModal(values)}
        modalityDetails={modalityDetails}
        setModalityDetails={setModalityDetails}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY.CAP_TOA.code]: (
      <ModalCapToaChoVe
        open={true}
        handleCloseModal={() => {
          handleCloseModal();
        }}
        handleSubmit={handleSubmitModal}
        benhNhanInfo={{
          visitId: benhNhanInfo?.thongTinKhamBenh?.visit?.id,
        }}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY.TU_VONG.code]: (
      <ModalCapNhatThongTinTuVong
        show={true}
        handleCloseDialog={() => {
          handleCloseModal();
        }}
		handleSubmit={handleSubmitModal}
		patientInfo={benhNhanInfo?.thongTinKhamBenh}
      />
    ),
	[MEDICAL_CONCLUSION_MODALITY.DIEU_TRI_NGOAI_TRU.code]: (
		<ModalDieuTriNgoaiTru 
			open={true}
			onClose={() => {
				handleCloseModal();
			}}
			onSave={(values: any) => {
				setModalityDetails({
					...modalityDetails,
					...values,
				});
				handleCloseModal();
			}}
			patientInfo={benhNhanInfo?.thongTinKhamBenh}
			itemEdit={{
				...values,
				treatmentDept: values?.treatmentDeptCode ? {
					code: values?.treatmentDeptCode,
					name: values?.treatmentDeptName,
					id: values?.treatmentDeptId,
				} : null,
				treatmentRoom: values?.treatmentRoomCode ? {
					code: values?.treatmentRoomCode,
					name: values?.treatmentRoomName,
					id: values?.treatmentRoomId,
				} : null,
			}}
		/>
	)
  };

  const handleChangeEncounterDiagnosis = (name: string, value: any) => {
    setFieldValue("encounterDiagnosis", {
      ...encounterDiagnosisValues,
      [name]: value,
    });
  };

  const getDataXuTri = async () => {
    try {
      if (benhNhanInfo?.thongTinKhamBenh?.orderId) {
        let { data } = await getDataXuTriService(
          benhNhanInfo?.thongTinKhamBenh?.orderId
        );
        if (data?.code === CODE.SUCCESS) {
          const medicalConclusion = listKQ?.find((item: any) => {
            return (
              item?.code ===
              data?.data?.encounterDiagnosis?.medicalConclusionCode
            );
          });
          
          const medicalConclusionModality = listHTXT?.find(
            (item: any) =>
              item?.code ===
              data?.data?.encounterDiagnosis?.medicalConclusionModalityCode
          );
          setValues({
            ...values,
            encounterDiagnosis: {
              ...data?.data?.encounterDiagnosis,
              medicalConclusionDate:
                data?.data?.encounterDiagnosis?.medicalConclusionDate ||
                formatDateDTO(new Date()),
            },
            medicalConclusionModality,
            medicalConclusion,
            isClinicalTransfer: data?.data?.isClinicalTransfer,
            isConclusion: data?.data?.isConclusion,
            appointment: data?.data?.appointment,
			treatmentDeptCode: data?.data?.treatmentDeptCode,
			treatmentDeptName: data?.data?.treatmentDeptName,
			treatmentRoomCode: data?.data?.treatmentRoomCode,
			treatmentRoomName: data?.data?.treatmentRoomName,
          });
		  setModalityDetails(data?.data?.modalityDetails);
          setIsDisabled(data?.data?.isDisabled);
        }
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra");
    }
  };

  useEffect(() => {
    resetForm();
    if (listKQ.length && listHTXT.length) getDataXuTri();
  }, [
    benhNhanInfo?.shouldUpdate,
    benhNhanInfo?.thongTinKhamBenh?.orderId,
    listKQ.length,
    listHTXT.length,
  ]);

  const getAppointment = async (visitId: string) => {
		try {
			const { code, data } = await getAppointmentByVisit(visitId);			
			if (CODE.SUCCESS === code) {
				setFieldValue('appointment', data);
			}
		} catch (error) {
			console.error(error);
		}
  };

  const onSubmit = ({submit, cancel}: {
    componentName: string,
    nameReq: string,
    cancel?: () => void
    submit: () => void,
    statusReq?: any
    }) => {
		submitForm();
    
    const isFormValid = !Object.keys(errors).length;
    if (!isFormValid) {
      cancel?.();
      return;
    };
     
		handleSubmit(values, submit, cancel);
  };

  const handleChangeICD10 = (data: any) => {
    setFieldValue('encounterDiagnosis', {
      ...encounterDiagnosisValues,
      ...data,
    });
  };

  const handleChangeDianosgisICD10 = (name: string, value: any) => {
    setFieldValue('encounterDiagnosis', {
      ...encounterDiagnosisValues,
      [name]: value,
    });
  };
  
  const getAdditionalProps = (values: any) => {
    let encounterDiagnosisValues = values?.encounterDiagnosis || {};
      let isClinicalTransfer =
        !benhNhanInfo?.thongTinKhamBenh?.component &&
        values?.medicalConclusionModality?.code ===
          MEDICAL_CONCLUSION_MODALITY.CHUYEN_PHONG.code;
      let transferOrderValue = modalityDetails?.transferOrderReq || {};
      const { transferOrderReq, ...modalityValue } = modalityDetails ?? {};
      let encounterDiagnosis = {
        id: encounterDiagnosisValues?.id,
        ...encounterDiagnosisValues,
        medicalConclusionCode: values?.medicalConclusion?.code,
        medicalConclusionName: values?.medicalConclusion?.name,
        medicalConclusionModalityCode: values?.medicalConclusionModality?.code,
        medicalConclusionModalityName: values?.medicalConclusionModality?.name,
      };
      
    return {
      orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
      modalityDetails: modalityValue,
      encounterDiagnosis: encounterDiagnosis,
      patientId: benhNhanInfo?.thongTinKhamBenh?.patient?.id,
      visitId: benhNhanInfo?.thongTinKhamBenh?.visit?.id,
      encounterId: benhNhanInfo?.thongTinKhamBenh?.encounter?.id,
      isClinicalTransfer,
      transferOrderReq: isClinicalTransfer ? transferOrderValue : {},
    }
  }

  return (
		<Form>
			<div className="spaces p-10 h-calc-vh-300 border-bottom bg-white spaces pb-80 overflow-y-auto">
				<Row className="mb-1">
					<Col xs={4} className="spaces mt-1">
						<div className="spaces mb-3">
							<div className="d-flex justify-content-between mb-1">
								<LabelRequired label="Chẩn đoán xác định" />
							</div>

							<TextField
								as="textarea"
								rows={2}
								name="finalDiagnosis"
								value={encounterDiagnosisValues?.finalDiagnosis || ''}
								disabled={isDisabled}
								onChange={(e: any) =>
									handleChangeEncounterDiagnosis('finalDiagnosis', e.target.value)
								}
								inputClassName="spaces h-60"
							/>
						</div>

						<div className="spaces pt-3">
							<div className="d-flex mb-1">
								<LabelRequired
									label="Nguyên nhân - ICD10"
									className="min-w-150px"
								/>
							</div>
							<TextField
								as="textarea"
								rows={2}
								name="icdXCause"
								disabled={isDisabled}
								value={encounterDiagnosisValues?.icdXCause || ''}
								onChange={(e: any) =>
									handleChangeEncounterDiagnosis('icdXCause', e.target.value)
								}
							/>
						</div>

						<div className="d-flex gap-2 spaces pt-4">
							<div className="flex-1">
								<div className="d-flex">
									<LabelRequired label="Thời gian xử trí" />
								</div>
							 	{values?.isConclusion && allowEdit ? (
									<div className="d-flex">
										<TimeEditor
											name="medicalConclusionDate"
											values={encounterDiagnosisValues}
											isEditingTime={timeEditorManager.isEditingTime}
											editedTime={timeEditorManager.editedTime}
											showValidationConfirm={timeEditorManager.showValidationConfirm}
											validationMessage={timeEditorManager.validationMessage}
											onEdit={timeEditorManager.handleEditTime}
											onCancel={timeEditorManager.handleCancelEdit}
											onSave={timeEditorManager.handleSaveTime}
											onConfirmValidation={timeEditorManager.handleConfirmValidation}
											onCancelValidation={timeEditorManager.handleCancelValidation}
											onTimeChange={timeEditorManager.setEditedTime}
											viewInputType
										/>
									</div>
								) : (
									<DatePickerCustom
										mode="date-time"
										name="medicalConclusionDate"
										value={encounterDiagnosisValues?.medicalConclusionDate}
										setDateValue={(date) =>
											handleChangeEncounterDiagnosis(
												'medicalConclusionDate',
												date
											)
										}
										errors={getIn(errors, 'encounterDiagnosis.medicalConclusion')}
										touched={getIn(touched, 'encounterDiagnosis.medicalConclusion')}
										disabled={isDisabled}
									/>
								)}
						  </div>
							<div className="flex-1">
								<div className="d-flex">
									<LabelRequired label="Kết quả điều trị" />
								</div>
								<AutocompleteObjectV2
									options={listKQ || []}
									name="medicalConclusion"
									value={values?.medicalConclusion}
									isDisabled={isDisabled}
									onChange={(option) =>
										setFieldValue('medicalConclusion', option)
									}
									errors={getIn(errors, 'medicalConclusion')}
									touched={getIn(touched, 'medicalConclusion')}
								/>
							</div>
						</div>

						<div className="w-50 spaces pt-8">
							<div className="d-flex">
								<LabelRequired label="Hình thức xử trí" isRequired />
							</div>
							<AutocompleteObjectV2
								options={listHTXT || []}
								name="medicalConclusionModality"
								isDisabled={isDisabled || benhNhanInfo?.thongTinKhamBenh?.component}
								value={values?.medicalConclusionModality}
								onChange={(option) => {
									handleSelectOption(option, 'medicalConclusionModality');
									setFieldValue('medicalConclusionModality', option);
								}}
								errors={getIn(errors, 'medicalConclusionModality')}
								touched={getIn(touched, 'medicalConclusionModality')}
							/>
						</div>
						<div className="spaces pt-22 flex-1 text-truncate">
							{modalityDetails?.clinic || ''}
						</div>
					</Col>

					<Col xs={8} className="ps-0">
						<div className="mb-2 spaces pt-4">
							<div className="d-flex justify-content-between">
								<LabelRequired label="Bệnh chính - ICD10" className="min-w-150px" />
								{!isDisabled && (
									<Button
										className="bg-white spaces pr-1 py-0"
										onClick={() => {
											setDiagnostic({
												fieldName: 'icdXPrimary',
												fieldLabel: 'ICD10',
												options: listICD10,
												comorbidityField: 'comorbidity',
												comorbidityCodeField: 'comorbidityCode',
											});
											setShouldOpenModalSelectICD10(true);
										}}
										disabled={isDisabled}
									>
										<u className="link-info">Chọn bệnh</u>
									</Button>
								)}
							</div>
							<Row className="spaces pe-0 align-items-center position-relative">
								<ProvisonalDiagnosis
									encounterDiagnosisValues={encounterDiagnosisValues}
									encounterDiagnosisErrors={getIn(errors, 'encounterDiagnosis')}
									encounterDiagnosisTouched={getIn(touched, 'encounterDiagnosis')}
									benhNhanInfo={benhNhanInfo}
									listComorbidity={listComorbidity}
									setListComorbidity={setListComorbidity}
									disabled={isDisabled}
									icd10Field="icdXPrimary"
									onChange={handleChangeICD10}
									handleChangeEncounterDiagnosis={handleChangeDianosgisICD10}
									comorbidityCodeField={diagnostic.comorbidityCodeField}
								/>
							</Row>
						</div>

						<div className="mb-2 spaces pt-4">
							<LabelRequired label="Bệnh kèm theo - ICD10" className="min-w-150px" />
							<Row className="spaces pe-0 align-items-center">
								<TextField
									name="comorbidity"
									as="textarea"
									rows={2}
									value={values?.encounterDiagnosis?.comorbidity || ''}
									disabled={isDisabled}
								/>
							</Row>
						</div>
						<div className="mb-2 spaces pt-4">
							<div className="d-flex justify-content-between">
								<LabelRequired label="Bệnh chính - YHCT" className="min-w-150px" />
								{!isDisabled && (
									<Button
										className="bg-white spaces pr-1 py-0"
										onClick={() => {
											setDiagnostic({
												fieldName: 'yhctPrimary',
												fieldLabel: 'YHCT',
												options: listYHCT,
												comorbidityField: 'yhctComorbidity',
												comorbidityCodeField: 'yhctComorbidityCode',
											});
											setShouldOpenModalSelectICD10(true);
										}}
										disabled={isDisabled}
									>
										<u className="link-info">Chọn bệnh</u>
									</Button>
								)}
							</div>
							<Row className="spaces pe-0 align-items-center position-relative">
								<ProvisonalDiagnosis
									encounterDiagnosisValues={encounterDiagnosisValues}
									encounterDiagnosisErrors={getIn(errors, 'encounterDiagnosis')}
									encounterDiagnosisTouched={getIn(touched, 'encounterDiagnosis')}
									benhNhanInfo={benhNhanInfo}
									listComorbidity={listComorbidity}
									setListComorbidity={setListComorbidity}
									disabled={isDisabled}
									icd10Field="yhctPrimary"
									onChange={handleChangeICD10}
									handleChangeEncounterDiagnosis={handleChangeDianosgisICD10}
									comorbidityField="yhctComorbidity"
									comorbidityCodeField="yhctComorbidityCode"
									fieldLabel="YHCT"
									diagnosisList={listYHCT}
									hasDiagnosisNonCoded={false}
								/>
							</Row>
						</div>

						<div className="spaces pt-4">
							<LabelRequired label="Bệnh kèm theo - YHCT" className="min-w-150px" />
							<Row className="spaces pe-0 align-items-center">
								<TextField
									name="yhctComorbidity"
									as="textarea"
									rows={2}
									value={encounterDiagnosisValues?.yhctComorbidity || ''}
									disabled={isDisabled}
								/>
							</Row>
						</div>
					</Col>
				</Row>

				<Row>
					<Col xs={12} className="spaces mt-1">
						<div>
							<div className="d-flex mb-1">
								<LabelRequired label="Lời dặn của bác sĩ" className="min-w-150px" />
							</div>
							<TextField
								as="textarea"
								rows={2}
								name="doctorComment"
								value={encounterDiagnosisValues?.doctorComment || ''}
								disabled={isDisabled}
								onChange={(e: any) =>
									handleChangeEncounterDiagnosis('doctorComment', e.target.value)
								}
								errors={getIn(errors, 'encounterDiagnosis.doctorComment')}
								touched={getIn(touched, 'encounterDiagnosis.doctorComment')}
							/>
						</div>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col md={4}>
						<DatePickerCustom
							label="Thời gian hẹn khám lại"
							labelClassName="spaces min-w-155"
							name="appointmentDate"
							value={
								isValidAppointment(values?.appointment)
									? values?.appointment?.scheduledDate
									: null
							}
							mode="date-time"
							disabled
						/>
					</Col>
				</Row>

				<div className="d-flex gap-3 bg-white flex-start position-fixed bottom-0 w-100 py-2">
					<ButtonInPhieu
						label="In phiếu khám bệnh"
						className="min-w-100px"
						fetchExport={inPhieuKhamBenh}
						params={{
							orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
						}}
					/>
					
					{benhNhanInfo?.thongTinKhamBenh?.orderId &&
						isValidAppointment(values?.appointment) && (
							<ButtonInPhieu
								fetchExport={printGiayHenKham}
								params={{
									fileType: 'pdf',
									id: values?.appointment?.id,
								}}
								label="In giấy hẹn khám lại"
								className="spaces px-16"
							/>
						)}

					{!values?.isConclusion &&
						benhNhanInfo?.thongTinKhamBenh?.orderId &&
						benhNhanInfo?.thongTinKhamBenh?.isMedicalExamStarted &&
						!benhNhanInfo?.thongTinKhamBenh?.isConclusion && (
							<DatLichHenButton
								patientInfo={benhNhanInfo?.thongTinKhamBenh}
								itemEdit={values?.appointment}
								onSuccess={() => {
									getAppointment(benhNhanInfo?.thongTinKhamBenh?.visit?.id);
								}}
							/>
						)}

					{!values?.isConclusion &&
						benhNhanInfo?.thongTinKhamBenh?.orderId &&
						benhNhanInfo?.thongTinKhamBenh?.isMedicalExamStarted && (
							<WfButton
								tracker={WfConstTracker.CLINICAL}
								objectId={benhNhanInfo?.thongTinKhamBenh?.orderId}
								forceRender={values?.isConclusion}
								handleClick={(data) => {
									onSubmit(data);
								}}
								additionalProps={getAdditionalProps(values)}
								additionalFunc={() => {
									setBenhNhanInfo({
										...benhNhanInfo,
										shouldUpdate: !benhNhanInfo?.shouldUpdate,
									});
									statusChangedEventFunc?.();
								}}
								componentName={componentName}
							/>
						)}

					{benhNhanInfo?.thongTinKhamBenh?.orderId && values?.isClinicalTransfer && (
						<ButtonInPhieu
							label="In phiếu"
							className="min-w-100px"
							fetchExport={inPhieuChuyenPK}
							params={{
								encounterId: benhNhanInfo?.thongTinKhamBenh?.encounter?.id,
								orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
								isClinicalTransfer: true,
							}}
						/>
					)}
				</div>
			</div>

			<DynamicModal compArray={compArray} nameComp={nameComp} />

			<ICD10
				shouldOpenModalICD10={shouldOpenModalICD10}
				setShouldOpenModalICD10={setShouldOpenModalICD10}
				shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
				setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10="radio"
				data={encounterDiagnosisValues}
				onChange={handleChangeICD10}
				listICD10={diagnostic.options}
				icd10Field={diagnostic.fieldName}
				fieldLabel={diagnostic.fieldLabel}
				comorbidityField={diagnostic.comorbidityField}
				comorbidityCodeField={diagnostic.comorbidityCodeField}
			/>
		</Form>
  );
};

const TabXuTriHOC = () => {
  const { benhNhanInfo } = useContext(PhanHeTiepDonContext);

  const formRef = useRef<any>(null);
  const { values, setFieldValue } = formRef?.current || {};
  const [listHTXT, setListHTXT] = useState<any[]>([]);
  const [listKQ, setListKQ] = useState<any[]>([]);
  const [modalityDetails, setModalityDetails] = useState<any>({});
  const [listICD10, setListICD10] = useState<any>([]);
  const [listYHCT, setListYHCT] = useState<any[]>([]);

  const intl = useIntl();
  const { combined, component } = benhNhanInfo?.thongTinKhamBenh || {};
  const isBenhNhanKhamKetHop = combined && component;
  const REQUIRE_MESSAGE = intl.formatMessage({ id: 'VALIDATION.REQUIRE' }); 
  const initialValidationSchema = Yup.object({
    encounterDiagnosis: Yup.object({
      icdXPrimary: Yup.string().required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' })).nullable(),
    }),
    medicalConclusionModality: Yup.mixed().test({
      name: "modicalConclusionModality",
      message: REQUIRE_MESSAGE,
      test: (value: any) => {
        if (isBenhNhanKhamKetHop) return true;
        return Boolean(value);
      },
    })
  });

  useEffect(() => {
    handleGetDanhMuc();
  }, []);

  useEffect(() => {
    setModalityDetails({});
  }, [values?.encounterDiagnosis?.medicalConclusionModality]);

  const handleSubmitXuTri = async (
		values: any,
		workflowCallbackFn?: () => Promise<any> | void,
		cancel?: () => void
  ) => {
		try {
			const data: any = await workflowCallbackFn?.();

			if (!data) {
				toast.success('Thành Công');
				setFieldValue(
					'isClinicalTransfer',
					!benhNhanInfo?.thongTinKhamBenh?.component &&
						values?.medicalConclusionModality?.code ===
							MEDICAL_CONCLUSION_MODALITY.CHUYEN_PHONG.code
				);
				return;
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
			cancel?.();
		} finally {
			cancel?.();
		}
  };

  const handleGetDanhMuc = async () => {
    try {
      let res: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      setListICD10(res?.listICD10 || []);
      setListHTXT(res?.listHTXT || []);
      setListKQ(res?.listKQDT || []);
      setListYHCT(res?.listYHocCoTruyen);
    } catch (error) {
      console.error(error);
    }
  };

  return (
		<Formik
			initialValues={{
				medicalConclusionModality: null,
				medicalConclusionDate: formatDateTime(new Date(), APP_TIMESTAMP_FORMAT),
			}}
			onSubmit={() => {}}
			validationSchema={initialValidationSchema}
			innerRef={formRef}
		>
			<div>
				<TabXuTri
					listHTXT={listHTXT}
					setListHTXT={setListHTXT}
					listKQ={listKQ}
					setModalityDetails={setModalityDetails}
					modalityDetails={modalityDetails}
					listICD10={listICD10}
					handleSubmit={handleSubmitXuTri}
          			listYHCT={listYHCT}
				/>
			</div>
		</Formik>
  );
};

export default TabXuTriHOC;
